goog.provide('el8.print.billing');

goog.require('el8.appservice.status');
goog.require('el8.data.init');
goog.require('el8.data.physicians');
goog.require('el8.data.practices');
goog.require('el8.data.practiceSettings');
goog.require('el8.ptdata.model.note.visit');
goog.require('el8.service.tz');
goog.require('el8.template.print.billing');
goog.require('el8.util.print');


el8.print.billing.init = function(spec) {

    el8.appservice.status.init();
    if (spec.data) { el8.data.init(spec.data); }
    el8.service.urls.init({
        serviceLocations: function(id) {
            return '/service-locations/' + (id ? id+'/' : '');
        }
    });

    var practice = el8.data.practices.create(spec.practice);
    var requestedDate = el8.service.tz.toTzDate(spec.requestedDate);

    var billed = spec.billed.map(function(a) {
        return el8.ptdata.model.note.bill(a).asSoyMap();
    });
    var unbilledUnsigned = spec.unbilledUnsigned.map(function(a) {
        return el8.ptdata.model.note.bill(a).asSoyMap();
    });
    var unbilledSigned = spec.unbilledSigned.map(function(a) {
        return el8.ptdata.model.note.bill(a).asSoyMap();
    });
    var vendorResponsible = spec.vendorResponsible.map(function(a) {
        return el8.ptdata.model.note.bill(a).asSoyMap();
    });

    var physician = spec.physician ? el8.data.physicians.create(spec.physician): null;
    var isExactDate = spec.isExactDate;

    $('.print-content').replaceWith(
        el8.template.print.billing.content({
            requestedDate: el8.service.tz.soyStr(requestedDate),
            physician: physician ? physician.asSoyMap() : null,
            isEmpty: (!billed.length && !unbilledUnsigned.length && !unbilledSigned.length),
            billed: billed,
            unbilledUnsigned: unbilledUnsigned,
            unbilledSigned: unbilledSigned,
            vendorResponsible: vendorResponsible,
            practice: practice.asSoyMap(),
            isExactDate: isExactDate,
            isInvoicingEnabled: el8.data.practiceSettings.isInvoicingEnabled(),
            now: el8.service.tz.soyStr(el8.service.tz.now())
        })
    );

    el8.util.print.pageSetup();

};

